/**
 * api/contextAudit.js — Auditoria de Contexto.
 *
 * Responde "o que o gerador de código realmente tem por projeto, e o que fica de fora".
 * GET /context-audit/projects · /context-audit/projects/:id · /context-audit/executions/:id/trace
 */
import { useQuery } from '@tanstack/react-query';
import { useApi } from './client';

export function useContextAuditProjects() {
  const api = useApi();
  return useQuery({
    queryKey: ['contextAudit', 'projects'],
    queryFn: () => api.get('/context-audit/projects'),
    staleTime: 30_000,
  });
}

export function useContextAudit(projectId) {
  const api = useApi();
  return useQuery({
    queryKey: ['contextAudit', 'project', projectId],
    queryFn: () => api.get(`/context-audit/projects/${projectId}`),
    enabled: Boolean(projectId),
    staleTime: 30_000,
  });
}

export function useExecutionTraceReport(executionId) {
  const api = useApi();
  return useQuery({
    queryKey: ['contextAudit', 'trace', executionId],
    queryFn: () => api.get(`/context-audit/executions/${executionId}/trace`),
    enabled: Boolean(executionId),
  });
}
